// extracted by mini-css-extract-plugin
export default {"content":"vnvaj","container":"_1HM4H","summary":"_3TZO6","expandIcon":"_3GRD-","mobile":"_3Ncqh"};